<div class="flex flex-col flex-auto w-full ">
<div class="p-4 bg-card shadow rounded-lg rounded-md rounded-sm rounded-xl my-4">
  <div class="ttl">How can we help You ..!</div>
  <mat-divider></mat-divider>
  <div class="container my-4">
    <mat-form-field style="    width: 60% !important;
    margin: 0px auto;
    display: block;">
      <input matInput placeholder="input search text">
      <button matSuffix mat-icon-button aria-label="Search">
        <mat-icon>search</mat-icon>
      </button>
    </mat-form-field>
  </div>

</div>
</div>